module.exports = __webpack_public_path__ + "img/lasource-25.1450f66e.jpg";